import { FormLabel, type FormLabelProps } from '@frontend/legacy-components';

export const HorizontalFormLabel = (props: FormLabelProps) => (
  <FormLabel flex="0 0 auto" h="auto" m={0} textAlign="right" {...props} />
);
